import  {ResourceType,Resources } from './Interface';
export enum ResourceTypes {
    LOAD_RESOURCES = 'LOAD/RESOURCES',
    LOADING_RESOURCES= 'LOADING?RESOURCES',
    LOAD_RESOURCE_DETAILS='LOAD/RESOURCE/DETAILS'
}

interface Resource_Loaded{
    type: typeof ResourceTypes.LOAD_RESOURCES,
    payload:{
        data:ResourceType
    }
}
interface ResourceDetails_Loaded {
    type: typeof ResourceTypes.LOAD_RESOURCE_DETAILS,
    payload:{
        data:Resources[]
    }
}

export type ResourceTypeAction = Resource_Loaded | ResourceDetails_Loaded

